export default __webpack_public_path__ + "static/media/invoicBackground.2b7664a6.svg";